import React from 'react';
import { SVG } from 'components/Elements';

export const X = props => (
    <SVG width="13" height="14" viewBox="0 0 13 14" stroke="black" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.1919 1L7.23047 5.96144M12.1919 13C9.97162 10.7797 9.35384 10.1619 7.23047 8.03856" stroke="black" />
        <path d="M0.481919 13L5.44336 8.03856M0.48192 1C2.70221 3.22029 3.31999 3.83807 5.44336 5.96144" stroke="black" />
    </SVG>
)